<template>
  <tr>
    <td>
      <b-button
        variant="danger"
        size="sm"
        @click="$emit('delete-ship-item', index)"
      >
        <i class="fas fa-trash-alt"></i>
      </b-button>
      <b-button
        :variant="this.syncColor"
        size="sm"
        @click="syncProduct()"
        v-b-popover.hover="this.item.id"
      >
        <i class="fas fa-sync-alt"></i>
      </b-button>
      <b-button
        :variant="item.special ? 'warning' : 'dark'"
        size="sm"
        v-b-popover.hover="item.special ? item.special[0] : 'No Special Shipping'"
        @click="$emit('edit-special', index)"
        @click.right.prevent="showShipSpecialString">

        <i class="fas fa-asterisk"></i>
      </b-button>
    </td>
    <td cols="2">
      <b-form-input type="text" v-model="item.sku" />
    </td>
    <td cols="1">
      <b-form-input type="number" v-model="item.quantity" :min="1" />
    </td>
    <td cols="1">
      <b-form-input 
      type="number" 
      v-model="item.value" 
      :min="0" 
      step="0.01" 
      :state="item.value > 0.0 ? null : 'invalid'"
      />
    </td>
    <td>
      <b-form-input
        v-if="!(item.special && item.special[0] == 'multipack')"
        v-b-popover.hover="item.weight == 0 ? 'Item has no weight' : ''"
        :state="item.weight > 0.0 ? null : 'invalid'"
        type="number"
        step="any"
        v-model="item.weight"
        :min="0.0"/>
    </td>
    <td>
      <b-form-input
        v-if="!(item.special && item.special[0] == 'multipack')"
        type="number"
        step="any"
        v-model="item.dimensions[0]"
        :state="item.dimensions[0] > 0.0 ? null : 'invalid'"
        :min="0.0"/>
    </td>
    <td>
      <b-form-input
        v-if="!(item.special && item.special[0] == 'multipack')"
        type="number"
        step="any"
        v-model="item.dimensions[1]"
        :state="item.dimensions[1] > 0.0 ? null : 'invalid'"
        :min="0.0"/>
    </td>
    <td>
      <b-form-input
        v-if="!(item.special && item.special[0] == 'multipack')"
        type="number"
        step="any"
        v-model="item.dimensions[2]"
        :state="item.dimensions[2] > 0.0 ? null : 'invalid'"
        :min="0.0"/>
    </td>
  </tr>
</template>

<script>
import WorkareaService from '../../services/workarea';

export default {
  name: 'ShippingItem',
  data() {
    return {
      syncColor: 'info',
    }
  },
  props: {
    index: {type: Number},
    item: {type: Object, default() { return {
      sku: '',
      id: '',
      quantity: 0,
      weight: 2,
      dimensions: [9,9,9]
    }; }}
  },
  computed: {
    validity() {
      let i = this.item;
      return `${(!!i.special && i.special[0] == 'multipack')} || (${(!!i.weight && i.weight > 0)} && ${i.dimensions.reduce((a,v) => a && (!!v && v > 0), true)})`
    }
  },
  methods: {
    showShipSpecialString() {
      console.log(this.item.special.join(','));
    },
    testFunction() {
      console.log("Working");
    },
    syncProduct() {
      WorkareaService.getProduct(this.item.id || this.item.sku).then( r => {
      if (r.product) {
        let i = r.product
        let sku = this.item.sku;
        let id = i.product_id;
        let details = i.details;
        let weight = 0;
        let dimensions = [];
        if(i.blank_item) {
          weight = this.item.product_attributes.weight / 16;
          dimensions = [9,12,12];
        } else {
          if(details['weight_oz_' + sku]) {
            weight = details['weight_oz_' + sku][0] / 16.0;
          } else if(details['weight_oz']) {
            weight = details['weight_oz'][0] / 16.0;
          } else {
            weight = 0;
          }

          if(details['dimensions_in_' + sku]) {
            dimensions = details['dimensions_in_' + sku];
          } else if(details['dimensions_in']) {
            dimensions = details['dimensions_in'];
          } else {
            dimensions = [9,12,12];
          }

          if (typeof dimensions[0] == 'string') {
            dimensions = dimensions.map((x) => {
              return x.replace(/\s+/g, '');
            })
          }
        }

        this.item.weight = weight;
        this.item.dimensions = dimensions;
        this.item.special = details['ship-special'];
        this.item.value = 1;

        this.syncColor = 'info';
      } else {
        this.syncColor = 'danger';
      }});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/ShippingItem.vue